import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Container fluid className="footer-section">
      <div className="footer-overlay">
        <Row className="footer-content-wrapper">
          {/* Left Column */}
          <Col lg={4} md={12} sm={12} className="footer-column-wrapper">
            <div className="footer-left">
              <Link to="/">
                <img
                  src={'/static/media/footer_logo.1cc7a3750246f8e90b27.png'}
                  alt="Alutuff ACP sheets logo"
                  className="footer-logo"
                  width="150"
                  height="48"
                />
              </Link>
              <div className="trust-text">
                <h2>Building Trust with Innovation, Quality Panels, and Global Manufacturing Excellence</h2>
                <p>
                  Alutuff delivers world-class aluminium panel solutions with trusted quality, modern design, and sustainable innovation.
                  Backed by global presence and decades of expertise, we serve architects, developers, and industries with durable, fire-rated, and aesthetic 
                  cladding solutions across India and beyond.
                </p>
              </div>
              <div className="social-icons">
                <a href="https://www.facebook.com/profile.php?id=61578129710470" target="_blank" rel="noopener noreferrer" aria-label="Alutuff Facebook"><FaFacebook /></a>
                <a href="https://www.linkedin.com/company/alutuff/" target="_blank" rel="noopener noreferrer" aria-label="Alutuff LinkedIn"><FaLinkedin /></a>
                <a href="https://www.instagram.com/alutuff.panels/" target="_blank" rel="noopener noreferrer" aria-label="Alutuff Instagram"><FaInstagram /></a>
              </div>
            </div>
          </Col>

          {/* Center Column - Quick Links */}
          <Col lg={3} md={6} sm={12} className="footer-column-wrapper">
            <div className="footer-column">
              <div className="col-text-div">
                <h4>Quick Links</h4>
                <div className="footer-links-column">
                  <Link to="/">Home</Link>
                  <Link to="/about">About Us</Link>
                  <Link to="/products">Products</Link>
                  <Link to="/career">Careers</Link>
                  <Link to="/contact">Contact Us</Link>
                  <Link to="/dealer">Become a Dealer</Link>
                </div>
              </div>
            </div>
          </Col>

          {/* Right Column - Contact Info */}
          <Col lg={3} md={5} sm={12} className="footer-column-wrapper">
            <div className="footer-column">
              <div className="col-text-div">
                <h4>Contact Info</h4>
                <div className="footer-contact-info">
                  <p><strong>Address:</strong><br />Alutuff International,<br />Choupla Road, Civil Lines, Bareilly, Uttar Pradesh, India.</p>
                  <p><strong>Phone:</strong><br />
                    <a href="tel:+916396854974">+91 63968 54974</a>
                  </p>
                  <p><strong>Email:</strong><br />
                    <a href="mailto:sales@alutuff.in">sales@alutuff.in</a>
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className='copyright-div' suppressHydrationWarning>
        Copyright © {currentYear} <span style={{ color: "#ea3138" }}>Alutuff</span>. All Right Reserved.
      </div>
    </Container>
  );
};

export default Footer;
